import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import HelperText from '../HelperText';

function Form({
  attrName,
  helperText: propHelperText,
  metaField,
  onChange,
  onInlineSubmit,
  resource,
  CustomProps,
  InputProps,
  SpreadProps,
  HelperProps,
  onAdd,
  onRemove,
  ...rest
}) {
  const Component = metaField.attr('_component');
  const helperText = propHelperText || '';

  if (metaField.attr('hidden')) {
    return null;
  }

  let canAddMore = true;
  if (metaField.attr('max')) {
    canAddMore = resource.attr(attrName).resources().length() < metaField.attr('max');
  }
  let canRemove = true;

  if (metaField.attr('min')) {
    canRemove = resource.attr(attrName).resources().length() > metaField.attr('min');
  }

  // TODO: #kevin - Rethink how we're rendering forms and if we should add additional configuration options
  if (!Component) {
    return null;
  }

  return (
    <Component
      helperText={
        <HelperText
          metaField={metaField}
          {...HelperProps}
          helperText={HelperProps.helperText || helperText}
        />
      }
      helperTextValue={HelperProps.helperText || helperText}
      title={metaField.attr('prompt')}
      className={metaField.nestedCollectionForm}
      collection={resource.attr(attrName)}
      onRemove={(onRemove && canRemove) ? onRemove : null}
      onAdd={(onAdd && canAddMore) ? () => {
        resource.attr(attrName).create({ addToCollection: true, useCollectionMetaOverrideSet: true });
        onAdd();
      } : null}
      addButtonText={onAdd && `Add ${pluralize(metaField.attr('prompt'), 1)}`}
      FormProps={{
        noIndividualSubmitButtons: true,
        onAdd,
        onRemove,
        onChangeCollection: onChange,
      }}
      {...SpreadProps}
      {...CustomProps}
      {...rest}
    />
  );
}

Form.defaultProps = {
  onInlineSubmit: undefined,
  HelperProps: {},
  onAdd: undefined,
  onRemove: undefined,
};

Form.propTypes = {
  HelperProps: PropTypes.object,
  attrName: PropTypes.string.isRequired,
  metaField: PropTypes.object.isRequired,
  onInlineSubmit: PropTypes.func,
  resource: PropTypes.object.isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

export default Form;
